import { createContext, useContext } from "react"

export type CortexContextValue = {
  /** Property IDs in the current dashboard scope (filter/selection). Used by Cortex for context. */
  propertyIds: string[]
}

const CortexContext = createContext<CortexContextValue>({ propertyIds: [] })

export function useCortexContext(): CortexContextValue {
  return useContext(CortexContext)
}

export const CortexProvider = CortexContext.Provider
